// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e9b4213b","453":"93f93605","667":"cff2425d","977":"9fbb10a1"}[chunkId] + ".chunk.js";
};